module.exports = __webpack_public_path__ + "img/complete_02.png";